import React from 'react'
import ReactDOM from 'react-dom'

const modalRoot = document.getElementById('modal-root')

class Modal extends React.Component {

  static defaultProps = {
    closelabel: 'Lukk'
  };

  render() {
    return ReactDOM.createPortal(
      <div className="reveal-overlay"  style={{
          display: 'block',
        }}>
        <div className="reveal" id="modal" data-reveal style={{
          display: 'block',
        }}>
          {this.props.children}
        </div>
      </div>,
      modalRoot,
    )
  }
}

export default Modal;
